(function (Translator) {
    // pl
    Translator.add("rate_list.rate.bg_kbcbank", "Kwota KBC Bank", "EvpThemeBundle", "pl");
    Translator.add("recaptcha.description", "Dana wiadomo\u015b\u0107 jest przeznaczona by udowodni\u0107, \u017ce nie jeste\u015b robotem, a tak\u017ce unikn\u0105\u0107 sprawdzania przez systemy automatyczne", "EvpThemeBundle", "pl");
    Translator.add("recaptcha.title", "Jeste\u015b robotem?", "EvpThemeBundle", "pl");
})(Translator);
